module.exports = __webpack_public_path__ + "static/media/delete.620ca4c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/delete.svg
// module id = 640
// module chunks = 0